module.exports = __webpack_public_path__ + "img/clear.b38a604d.png";